// extracted by mini-css-extract-plugin
module.exports = {"section":"Repositories-module--section--197Y_","sectionTitle":"Repositories-module--sectionTitle--25xQf","repos":"Repositories-module--repos--3YPKa"};